import type { FetchUnsignedPrivacyPolicy } from '../../api/types/privacyPolicies.types';

import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export default function useUnsignedPrivacyPolicy({
  language,
}: FetchUnsignedPrivacyPolicy) {
  const { queryFn, queryKey } =
    queryKeys.privacyPolicies.fetchUnsignedPrivacyPolicy({
      language,
    });
  return useQuery({
    queryFn,
    queryKey,
  });
}
